// extracted by mini-css-extract-plugin
export default {"style-box":"ErrorBoundaries_style-box","content":"ErrorBoundaries_content"};